import type { ReactNode } from 'react';

/**
 * A single headline number. The value uses the display serif so the dashboard
 * reads like a report rather than a control panel.
 */
export function KpiTile({
  label,
  value,
  hint,
  accent = 'blue',
  icon,
}: {
  label: string;
  value: string;
  hint?: string;
  accent?: 'blue' | 'coral' | 'cyan' | 'gold';
  icon?: ReactNode;
}) {
  const accents = {
    blue: 'var(--color-blue-500)',
    coral: 'var(--color-coral-500)',
    cyan: 'var(--color-cyan-600)',
    gold: 'var(--color-gold-400)',
  } as const;

  return (
    <div className="card relative overflow-hidden px-5 py-4">
      <span className="absolute inset-y-0 left-0 w-1" style={{ background: accents[accent] }} aria-hidden />
      <div className="flex items-start justify-between gap-3">
        <p className="label !mb-0">{label}</p>
        {icon && <span aria-hidden>{icon}</span>}
      </div>
      <p className="nums mt-2 font-display text-[28px] leading-none font-semibold">{value}</p>
      {hint && <p className="mt-1.5 text-[12px] text-[var(--color-ink-muted)]">{hint}</p>}
    </div>
  );
}
